module.exports = __webpack_public_path__ + "static/accordionFront-47f737d24686d25a285b9541e286990d.png";